/**
 * **Перечисления для аналитики**
 *
 * _Определяет константы и перечисления для аналитических API._
 *
 * @module analytics-enums
 */

/**
 * **Поисковые функции**
 *
 * _Доступные функции поиска для отслеживания._
 */
export enum SearchFunction {
  /** Использование фильтров */
  FILTER = 'filter',
  /** Использование автоподсказок */
  HINT = 'hint',
  /** Использование истории */
  HISTORY = 'history',
  /** Использование популярных автоматических запросов */
  POPULAR_AUTO_QUERIES = 'popular_auto_queries',
  /** Использование популярных ручных запросов */
  POPULAR_MANUAL_QUERIES = 'popular_manual_queries',
  /** Использование популярных рекомендуемых запросов */
  RECOMMENDED_QUERIES = 'recommended_queries'
}

/**
 * **Источники конверсии по товарам**
 *
 * _Источники, откуда пользователь пришел к товару._
 */
export enum ProductConversionSource {
  /** Поиск по запросу */
  SEARCH = 'search',
  /** Список популярных товаров (авто) */
  POPULAR_AUTO_PRODUCTS = 'popular_auto_products',
  /** Список популярных товаров (ручной) */
  POPULAR_MANUAL_PRODUCTS = 'popular_manual_products',
  /** Список похожих товаров */
  SIMILAR_PRODUCTS = 'similar_products',
  /** Up Sell товары */
  UP_SELL_PRODUCTS = 'up_sell_products',
  /** Cross Sell товары */
  CROSS_SELL_PRODUCTS = 'cross_sell_products',
  /** Недавно просмотренные товары */
  RECENTLY_WATCHED_PRODUCTS = 'recently_watched_products',
  /** Рекомендуемые товары */
  RECOMMENDED_PRODUCTS = 'recommended_products',
  /** Рекомендуемые товары по запросу */
  RECOMMENDED_QUERY_PRODUCTS = 'recommended_query_products',
  /** Каталог */
  CATALOG = 'catalog'
}

/**
 * **Типы конверсии по товару**
 *
 * _Действия пользователя с товаром._
 */
export enum ProductConversionType {
  /** Клик */
  CLICK = 'click',
  /** Добавление в корзину */
  BASKET = 'basket',
  /** Оформление заказа */
  ORDER = 'order'
}

/**
 * **Источники конверсии по категориям**
 *
 * _Источники, откуда пользователь пришел к категории._
 */
export enum CategoryConversionSource {
  /** Поиск по запросу */
  SEARCH = 'search'
}

/**
 * **Типы конверсии по категории**
 *
 * _Действия пользователя с категорией._
 */
export enum CategoryConversionType {
  /** Клик */
  CLICK = 'click'
}
